<div class="linked-search-frame">

    <div class="header-container">

        <div class="title">
            <ng-content select="[title]"></ng-content>
            <ng-template [ngIf]="titleKey">{{titleKey | translate}}</ng-template>
        </div>

        <div class="commands">
            <ng-content select="[commands]"></ng-content>


            <div class="command-filter-area">
                <ng-content select="[command-filter-area]"></ng-content>
            </div>

            <button *ngIf="useAdvancedSearch"
                    class="btn btn-link advanced-search-link"
                    (click)="toggleRightSideBar($event)">
                <img src="/assets/images/icons/ico-advanced-search-blue.svg" alt="Advanced Search" />
                <span>{{ 'Common.SearchActionsAndDetailsActions.AdvancedSearch' | translate }}</span>
            </button>

        </div>

    </div>

    <div class="body-container">
        <loader [show]="isLoading"></loader>
        <div class="content-container">
            <div class="results-container">
                <ng-content select="[results-area]"></ng-content>
            </div>

            <div class="right-sidebar-container" [class.opened]="showRightSidebar" #rightSideBarContainer>
                <ng-content select="[right-sidebar-area]"></ng-content>
            </div>
        </div>
    </div>
</div>